<template src="./template.html"></template>
<style src="./styles.scss" lang="scss"></style>
<style src="./topic.scss" lang="scss"></style>

<script>
  import { mapActions, mapState, mapGetters } from 'vuex'
  import { isMobile } from 'mobile-device-detect'
  import TopicInfo from './TopicInfo'
  import GroupFiles from '@/components/modules/group/GroupFiles'
  import GroupMembers from '@/components/modules/group/GroupMembers'
  import EditTopicOverlay from '@/components/overlays/EditTopicOverlay'
  import ConfirmationOverlay from '@/components/overlays/ConfirmationOverlay'
  import CreatePost from '@/components/modules/CreatePost'

  export default {
    name: 'GroupTopicPage',
    metaInfo() {
      return {
        title: this.$t('meta.group_topic.title', { name: this.topic && this.topic.infos ? this.topic.infos.title : '' }),
      }
    },
    components: {
      TopicInfo,
      ConfirmationOverlay,
      NewsStream: () => import('@/components/modules/NewsStream'),
      CreatePost,
      EditTopicOverlay,
      GroupFiles,
      GroupMembers,
    },
    data() {
      return {
        selectedTab: 'info',
        selectedOverlay: null,
        suggestionOverlay: false,
        usersPerPage: 0,
      }
    },
    computed: {
      ...mapState('topics', [
        'topic',
        'pending',
      ]),
      ...mapState('auth', { activeUser: 'user' }),
      ...mapGetters('topics', [
        'canDeleteTopic',
        'canEditTopic',
        'canPostContent',
      ]),
      getDeleteTopicObject() {
        return {
          title: this.$t('topic.overlays.delete_topic.title'),
          img: this.topic && this.topic.infos && this.topic.infos.img,
          text: this.$t('topic.overlays.delete_topic.text'),
          button_text: this.$t('topic.overlays.delete_topic.button_text'),
        }
      },
    },
    watch: {
      selectedTab: function(val) {
        if (val === 'members') {
          this.clearTopicMembers()
          this.getTopicMembers({ id: this.$route.params.id, options: { page: 1, per_page: this.usersPerPage } })
        }
        if (this.$route.query && this.$route.query.selectedTab !== val) {
          this.$router.replace({ query: { selectedTab: val } })
        }
      },
    },
    created() {
      this.usersPerPage = isMobile ? 8 : 15
      this.requestTopic()
      if (this.$route.query && this.$route.query.selectedTab) {
        this.selectedTab = this.$route.query.selectedTab
      }
    },
    destroyed() {
      this.clearTopic()
    },
    methods: {
      ...mapActions('topics', [
        'checkTopic',
        'clearTopic',
        'clearTopicMembers',
        'deleteTopic',
        'editTopic',
        'getTopic',
        'getTopicMembers',
        'getTopicSuggestions',
      ]),
      ...mapActions('posts', [ 'getOptionsForTopic' ]),
      requestTopic() {
        this.getTopic(this.$route.params.id).then(_ => {
          if (this.topic && this.topic.group) {
            this.getOptionsForTopic(this.topic.group.id)
          }
        })
      },
      closeOverlay() {
        this.selectedOverlay = null
      },
      actionDeleteTopic() {
        if (this.topic) {
          this.deleteTopic(this.topic.id).then(_ => {
            if (this.topic.group) {
              this.$router.replace({ name: 'group', params: { id: this.topic.group.id } })
            }
          })
        }
      },
      openOverlay(overlay) {
        if (this.topic) {
          this.checkTopic(this.topic.id).then(status => {
            if (status && status === -1) {
              return false
            }
            this.selectedOverlay = overlay
          })
        }
      },
      submitTopic(args) {
        const topic_id = this.$route.params.id
        const group_id = this.$route.params.group_id
        const title = args.title
        const description = args.description
        this.editTopic({ id: topic_id, payload: { group_id, title, description } }).then(_ => {
          this.closeOverlay()
          this.getTopic(this.$route.params.id)
        })
      },
      showMoreMembers() {
        this.getTopicMembers({
          id: this.$route.params.id,
          options: {
            page: this.topic && this.topic.members && this.topic.members.pagination && this.topic.members.pagination.next,
            per_page: this.usersPerPage,
          },
        })
      },
    },
  }
</script>
